import { LOCATION } from 'shared/settings/regions';
import { type IFilter } from 'shared/types/filter';

export const defaultFilterInitialState: IFilter = {
  apartmentsWithDecoration: false,
  deadline: undefined,
  deadlineVariants: [],
  location: LOCATION.MOSCOW_AND_AREA.ID,
  locationVariants: [],
  maxArea: undefined,
  maxPrice: undefined,
  minArea: undefined,
  minPrice: undefined,
  readyApartments: false,
  rooms: [],
  seriaPlus: false,
};
